import { render, staticRenderFns } from "./Classification.vue?vue&type=template&id=0498a024&scoped=true&"
import script from "./classification.js?vue&type=script&lang=js&"
export * from "./classification.js?vue&type=script&lang=js&"
import style0 from "./Classification.vue?vue&type=style&index=0&id=0498a024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0498a024",
  null
  
)

export default component.exports